(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5821],{

/***/ 48830:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/login",
      function () {
        return __webpack_require__(60807);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 60807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Login; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var _backpackjs_storefront__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52031);
/* harmony import */ var _backpackjs_storefront__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _templates_account__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11292);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42310);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

/* eslint-disable import/no-unresolved */ 



var LoginTemplate = _templates_account__WEBPACK_IMPORTED_MODULE_3__/* ["default"].login */ .Z.login;
var authOptions = {
    autoRedirect: true,
    defaultRoute: "/account/orders",
    id: "withLogin"
};
var __N_SSG = true;
function Login(param) {
    var initialSettings = param.settings;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("login"), action = ref[0], setAction = ref[1];
    var liveSettings = (0,_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_2__.useSettings)();
    var settings = liveSettings || initialSettings;
    // will redirect to account if signed in
    var authenticated = (0,_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_2__.useCustomerAuth)(authOptions).authenticated;
    var _obj;
    return authenticated === false ? LoginTemplate ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LoginTemplate, (_obj = {
        action: action,
        setAction: setAction
    }, _defineProperty(_obj, "action", action), _defineProperty(_obj, "setAction", setAction), _defineProperty(_obj, "settings", settings), _obj)) : "Login template not provided" : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .AccountsAuthLoader */ .iT, {}) // while you get redirected
    ;
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9349,1292,9774,2888,179], function() { return __webpack_exec__(48830); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);